module.exports = __webpack_public_path__ + "13e8c81a134156ffdb5aae78871e268d.png";